/* locales */
import routesEscl from '../locales/es-CL/routes.json';
import routesEsmx from '../locales/es-MX/routes.json';
import routesEsco from '../locales/es-CO/routes.json';
import routesEnus from '../locales/en-US/routes.json';
import tripsEscl from '../locales/es-CL/trips.json';
import tripsEsmx from '../locales/es-MX/trips.json';
import tripsEsco from '../locales/es-CO/trips.json';
import tripsEnus from '../locales/en-US/trips.json';
import activitiesEscl from '../locales/es-CL/activities.json';
import activitiesEsmx from '../locales/es-MX/activities.json';
import activitiesEsco from '../locales/es-CO/activities.json';
import activitiesEnus from '../locales/en-US/activities.json';
import documentsEscl from '../locales/es-CL/documents.json';
import documentsEsmx from '../locales/es-MX/documents.json';
import documentsEsco from '../locales/es-CO/documents.json';
import documentsEnus from '../locales/en-US/documents.json';
import itemsEscl from '../locales/es-CL/items.json';
import itemsEsmx from '../locales/es-MX/items.json';
import itemsEsco from '../locales/es-CO/items.json';
import itemsEnus from '../locales/en-US/items.json';

/* components */
import showRouteDetail from '../routeDetailModal/routeDetailModalHandler';
import Multiselect from 'vue-multiselect';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import showAlert from '@waypoint/vue-alert';
import showConfirmation from '@waypoint/vue-confirmation';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';

/* utils */
import { formatNominalTime } from '../utils/DateUtils';

/* resources */
import badgeStylesRoute from '../resources/badgeStylesRoute.json';
import itemTableSchema from '../resources/itemTableSchema.json';
import documentTableSchema from '../resources/documentTableSchema.json';
import activityTableSchema from '../activities/activityTableSchema.json';
import tripTableSchema from '../trips/tripTableSchema.json';
import routeTableSchema from './routeTableSchema.json';
import routeStatus from '../resources/routeStatus.json';
import activityTypes from '../resources/activityTypes.json';
import documentClasses from '../resources/documentClasses.json';

/* auxiliar methods */
import { generateInformation, generateLocalization, generateMassiveRouteSchema } from './massiveRoutesSchema';
import showRoutesForm from '@/routes/routesFormHandler';
import showTripsForm from '../trips/tripsFormHandler';
import axios from 'axios';
/* libraries */
import moment from 'moment';
import Container from 'typedi';

/* services */
import RouteService from '../services/RouteService';
import DocumentService from '../services/DocumentService';
import ItemService from '../services/ItemService';
import SpotService from '../services/SpotService';
import TripService from '../services/TripService';
import ActivityService from '../services/ActivityService';
import DriverService from '../services/DriverService';
import VehicleService from '../services/VehicleService';
import LogService from '../services/LogService';

/* exceptions */
import DocumentExistsException from '../exceptions/DocumentExistsException';
import NoRouteException from '../exceptions/NoRouteException';
import InvalidRouteTimeException from '../exceptions/InvalidRouteTimeException';
import NoTripsException from '../exceptions/NoTripsException';
import NoActivitiesException from '../exceptions/NoActivitiesException';
import NoValidSpot from '../exceptions/NoValidSpot';
import InvalidAssignationException from '../exceptions/InvalidAssignationException';

const baseCell = {
  class: 'text-center',
  tdClass: 'small',
  sortable: false,
};

export default {
  name: 'Routes',
  i18n: {
    messages: {
      'es-CL': {
        routes: routesEscl,
        trips: tripsEscl,
        activities: activitiesEscl,
        documents: documentsEscl,
        items: itemsEscl,
      },
      'es-MX': {
        routes: routesEsmx,
        trips: tripsEsmx,
        activities: activitiesEsmx,
        documents: documentsEsmx,
        items: itemsEsmx,
      },
      'es-CO': {
        routes: routesEsco,
        trips: tripsEsco,
        activities: activitiesEsco,
        documents: documentsEsco,
        items: itemsEsco,
      },
      'en-US': {
        routes: routesEnus,
        trips: tripsEnus,
        activities: activitiesEnus,
        documents: documentsEnus,
        items: itemsEnus,
      },
    },
  },
  components: {
    Multiselect,
    VueCtkDateTimePicker,
    GoogleMapsApiLoader,
  },
  data() {
    return {
      isCrudBusy: false,
      resultValidation: null,
      rowsExcelTranform: [],
      optionsSpots: [],
      routeRowsExcel: null,
      tripRowsExcel: null,
      activityRowsExcel: null,
      documentRowsExcel: null,
      itemRowsExcel: null,
      fileExcel: null,
      clientList: [],
      routeSelectedEnd: null,
      routeService: null,
      showFilters: false,
      documentService: null,
      driverService: null,
      vehicleService: null,
      logService: null,
      activityService: null,
      tripService: null,
      itemService: null,
      spotService: null,
      // otros
      spot: null,
      temporalCommentEndRoute: '',
      dataAccess: null,
      countryList: [],
      valueList: [],
      shortCutPath: null,
      isFilterApplied: false,
      statusSelected: '',
      statusOption: [],
      isBusy: false,
      isCancelRouteBusy: false,
      routeToCancel: null,
      counterTemporalSpot: 0,
      totalRouteRows: 0,
      currentPage: 1,
      currentPageTrips: 1,
      currentPageActivities: 1,
      currentPageDocuments: 1,
      currentPageItems: 1,
      perPage: 10,
      perPageTrips: 10,
      perPageActivities: 10,
      perPageDocuments: 10,
      perPageItems: 10,
      pageOptions: [10, 15, 20, 50, 100],
      sortBy: '',
      sortDesc: false,
      keyword: '',
      routes: [],
      trips: [],
      activities: [],
      documents: [],
      itemsDetails: [],
      currentTab: 'rutas',
      loadAllData: false,
      isFilterClicked: false,
      showExcel: false,
      excelData: [],
      itemData: [],
      itemTypeData: [],
      tags: [],
      routeInfoSelected: null,
      selectedRoute: null,
      selectedTrip: null,
      selectedActivity: null,
      selectedDocument: null,
      selectedItem: null,
      routeResult: '',
      spotBusy: false,
      filters: {
        from: null,
        until: null,
        spots: null,
        routeId: '',
        routeStatus: '',
        vehicle: null,
        driver: null,
        tripId: '',
        itemType: null,
        documentNumber: '',
        name: '',
        tags: [],
        extraData: null,
      },
      dynamicOptions: {
        destination: [],
        origin: [],
        vehicle: [],
        driver: [],
        itemType: [],
        spots: [],
      },
      badges: badgeStylesRoute,
      gapi: null,
      routeSelected: [],
      selectedAllRoute: false,
      loadingSpinnerHelperVariables: {
        cancelRoute: {
          indexAssigned: -1,
          unAssignedNotLoading: true,
        },
      },
    };
  },
  async created() {
    // inyeccion de dependencias
    this.routeService = Container.get(RouteService);
    this.documentService = Container.get(DocumentService);
    this.itemService = Container.get(ItemService);
    this.spotService = Container.get(SpotService);
    this.driverService = Container.get(DriverService);
    this.activityService = Container.get(ActivityService);
    this.tripService = Container.get(TripService);
    this.vehicleService = Container.get(VehicleService);
    this.logService = Container.get(LogService);
    // startup
    GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    this.routeEvents = await this.getAlerts();
    this.prepareData();
  },
  methods: {
    async getCountryList() {
      var url = `${this.$store.getters.urlAPI}/api/country`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const response = await axios.get(url, config);
      console.log(response);
      response.data.data.forEach((element) => {
        if (element.iso === 'CL' || element.iso === 'MX') {
          this.countryList.push({
            id: element.id,
            name: element.name,
            iso: element.iso,
          });
        }
      });
      if (this.countryList.length > 0) {
        console.log('Listado de paises listo!');
        this.sortCountryList();
      } else {
        console.log('Listado de paises no listo. No se pueden crear ordenes!');
      }
    },
    async getAlerts() {
      const today = new Date().valueOf();
      const fiveDaysAgo = today - 86400000 * 5;
      const urlAlert = `${this.$store.getters.urlAPI}/alert?startDateFilter=${fiveDaysAgo}&endDateFilter=${today}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const alertPromise = await axios.get(urlAlert, config);
        return alertPromise.data.data;
      } catch (e) {
        this.logService.sendError({
          component: "routes",
          message: `getAlerts fallo en su procesamiento ${e.message}`
        });
        console.log(e);
        return [];
      }
    },
    sortCountryList() {
      this.countryList.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a y b son iguales.
        return 0;
      });
    },
    /* metodos de carga de componentes de ruta */
    async loadRoutes() {
      this.keyword = '';
      const filters = this.retrieveFilterData();
      this.cleanCheckBox();
      const routesPages = await this.routeService.getRoutes(this.currentPage, this.perPage, filters);
      this.totalRouteRows = routesPages.paginator ? routesPages.paginator.totalRows : 0;
      this.routes = routesPages.data || [];
      this.checkDocumentRoute();
    },
    async loadTrips() {
      this.keyword = '';
      this.routeInfoSelected = await this.routeService.getRoute(this.selectedRoute);
      //this.trips = await this.tripService.getTripsByIdRoute(this.selectedRoute);    <- posible llamada innecesaria
      this.trips = this.routeInfoSelected.trips;
      this.trips.reverse();
    },
    async loadActivities() {
      this.keyword = '';
      this.activities = await this.activityService.getActivitiesByIdTrip(this.selectedTrip);
    },
    async loadDocuments() {
      this.keyword = '';
      this.documents = await this.documentService.getDocumentsByIdActivity(this.selectedActivity);
    },
    async loadItemsDetails() {
      this.itemsDetails = await this.itemService.getItemsByIdDocument(this.selectedDocument);
    },
    async checkDocumentRoute() {
      if (this.filters.documentNumber && this.routes.length > 0) {
        console.log('lo encontre');
        this.routeResult = await this.routeService.getRoute(this.routes[0].id);
        this.selectedRoute = this.routeResult.id;
        let tripRet = this.routeResult.trips;
        for (let tripObj of tripRet) {
          for (let activityObj of tripObj.activities) {
            for (let documentObj of activityObj.documents) {
              if (this.filters.documentNumber === documentObj.number) {
                this.selectedTrip = tripObj.id;
                this.selectedActivity = activityObj.id;
                break;
              }
            }
          }
        }
        await this.loadTrips();
        await this.loadActivities();
        await this.loadDocuments();
        this.currentTab = 'documentos';
      }
    },
    /**
     * Metodo que envia al modal de detalle de cumplimiento
     * @param {Integer} routeID
     */
    async prepareRouteFulfillmentDetail(routeID) {
      let events = [];
      this.routeEvents.forEach((event) => {
        if (event.idRoute == routeID) {
          //Alerta de panico
          if (event.alertType == 102) {
            event.eventType = 109;
          }
          //Alerta de Jammer
          if (event.alertType == 103) {
            event.eventType = 108;
          }
          events.push(event);
        }
      });
      await this.$store.commit('saveRouteDetailCounter', this.autoRefreshTimer);
      showRouteDetail(routeID, events, 'edit', null);
    },
    sendInfoRoute(route) {
      this.routeSelectedEnd = route;
    },
    async getClients() {
      const urlClients = `${this.$store.getters.urlAPI}/api/client/all`;
      this.clientList = [];
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlClients, config);
        response.data.data.forEach((element) => {
          this.clientList.push(element);
        });
        this.clientList.sort(function (a, b) {
          if (a.name[0] > b.name[0]) {
            return 1;
          }
          if (a.name[0] < b.name[0]) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } catch (e) {
        console.log(e);
      }
    },
    /* metodos de carga de datos complementarios */
    async getDrivers() {
      const includeOnlyUsers = false;
      const drivers = await this.driverService.getDrivers(includeOnlyUsers);
      this.dynamicOptions.driver = drivers;
      this.dynamicOptions.driver.forEach((driver) => {
        driver.fullName = this.transformWords(driver.firstName) + '  ' + this.transformWords(driver.lastName);
        driver.fullNameAndClient = driver.fullName + " | " + this.clientList.find((client) => client.id === driver.idClient).name 
      });
    },
    async getVehicles() {
      const vehicles = await this.vehicleService.getVehicles();
      this.dynamicOptions.vehicle = vehicles;
      this.dynamicOptions.vehicle.forEach((vehicle) => {
        vehicle.plateAndClient = vehicle.plate + " | " + this.clientList.find((client) => client.id === vehicle.idClient).name 
      });
    },
    async getStatus() {
      this.statusOption = await this.routeService.getStatus();
    },
    async sendCancelRoute(idRoute) {
      const url = `${this.$store.getters.urlAPI}/route/${idRoute}/canceled`;
      console.log('url', url);
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      console.log('config', config);
      const body = {
        statusCreatedAt: (new Date()).getTime()
      };
      try {
        await axios.patch(url, body, config);
      } catch (e) {
        this.logService.sendError({
          component: "routes",
          message: `sendCancelRoute fallo en su procesamiento ${e.message}`
        });
        showAlert('Error', e.response.data);
      }
    },
    async getTags() {
      try {
        const url = `${this.$store.getters.urlAPI}/tag`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        let filterTag = response.data.data.filter((tag) => tag.enabled === true);
        return filterTag;
      } catch (e) {
        console.log(e);
      }
    },
    /* metodo orquestado de preparación de datos */
    async prepareData() {
      localStorage.removeItem('currentRoute');
      localStorage.removeItem('currentTrip');
      localStorage.removeItem('currentActivity');
      localStorage.removeItem('currentDocument');
      if (localStorage.getItem('openExcel') == 'true') {
        this.isBusy = true;
        this.getCountryList();
        this.dynamicOptions.spots = await this.spotService.getSpots();
        const itemData = await this.itemService.getItems();
        this.itemTypeData = await this.itemService.getTypes();
        this.tags = await this.getTags();
        this.itemData = itemData;
        this.dynamicOptions.itemType = itemData;
        this.dataAccess = this.$store.getters.dataAccess;
        await this.prepareInstantFilter();
        await this.getClients();
        await this.getDrivers();
        await this.getVehicles();
        this.showModal('save-massive-modal');
        localStorage.setItem('openExcel', false);
        this.getStatus();
        await this.loadRoutes();
        this.valueList = await this.getValueExtraDataTrips();
        this.isBusy = false;
        this.loadAllData = true;
      } else {
        this.dataAccess = this.$store.getters.dataAccess;
        this.isBusy = true;
        await this.prepareInstantFilter();
        await this.getClients();
        await this.getDrivers();
        await this.getVehicles();
        this.getStatus();
        await this.loadRoutes();
        this.valueList = await this.getValueExtraDataTrips();
        this.isBusy = false;
        this.dynamicOptions.spots = await this.spotService.getSpots();
        await this.getCountryList();
        const itemData = await this.itemService.getItems();
        this.itemTypeData = await this.itemService.getTypes();
        this.tags = await this.getTags();
        this.itemData = itemData;
        this.dynamicOptions.itemType = itemData;
        this.loadAllData = true;
      }
    },
    /* metodos de filtrado */
    //Metodo encargado de preparar un filtro instantaneo de la id de la ruta.
    async prepareInstantFilter() {
      this.shortCutPath = await this.$store.getters.shortCutPathOrigin;
      this.filters.routeId = await this.$store.getters.idRouteFlash;
      this.$store.commit('cleanIdRouteFlash');
      this.$store.commit('cleanShortCutPathOrigin');
    },
    retrieveFilterData() {
      //Se prepara el link.
      const filters = {};
      this.isFilterApplied = false;
      //Se verifica cada filtro, si el filtro de aplica: se agrega al link.
      if (this.filters.from) {
        const dateFrom = new Date(this.filters.from);
        const secondsFrom = dateFrom.getTime();
        filters.startDate = secondsFrom;
      }
      if (this.filters.until) {
        const dateUntil = new Date(this.filters.until);
        const secondsUntil = dateUntil.getTime();
        filters.endDate = secondsUntil;
      }
      if (this.filters.origin && this.filters.origin.length > 0) {
        filters.idOrigin = this.filters.origin;
      }
      if (this.filters.destination && this.filters.destination.length > 0) {
        filters.idDestination = this.filters.destination;
      }
      if (this.filters.routeStatus && this.filters.routeStatus.length > 0) {
        filters.idStatus = this.filters.routeStatus;
      }
      if (this.filters.name) {
        filters.name = this.filters.name;
      }
      if (this.filters.documentNumber) {
        filters.documentNumber = this.filters.documentNumber;
      }
      if (this.filters.tags){
        filters.idsTag = this.filters.tags;
      }
      if (this.filters.routeId) {
        filters.routeId = this.filters.routeId;
      }
      if (this.filters.extraData) {
        const encodedValue = encodeURIComponent(this.filters.extraData);
        filters.extraData = encodedValue;
      }
      if (this.filters.driver && this.filters.driver.length > 0) {
        console.log('filtros dri', this.filters.driver);
        filters.driver = this.filters.driver;
      }
      if (this.filters.vehicle && this.filters.vehicle.length > 0) {
        console.log('filtros veh', this.filters.vehicle);
        filters.vehicle = this.filters.vehicle;
      }

      this.isFilterApplied = Object.keys(filters).length > 0;
      console.log('filtros enviados', filters);
      return filters;
    },
    superFilterModified() {
      const now = new Date();
      this.routes = this.routes.filter((item) => {
        const date72 = new Date(item.modifiedAt);
        date72.setHours(date72.getHours() + 72);

        return item.status > 6 ? now < date72 : true;
      });
      console.log('rutas despues del filtro', this.routes);
    },
    /* metodos de carga masiva */
    openExcel() {
      this.excelData = [];
      this.showExcel = true;
    },
    closeExcel() {
      this.showExcel = false;
      localStorage.setItem('openExcel', false);
    },
    limitText(count) {
      return this.$t('routes.search.limitText') + (count + 1);
    },
    preSubmitValidation(validRows, showError, highlightError, setSaveButtonAvailability) {
      setSaveButtonAvailability(false);
      try {
        this.routeService.validateMassiveRouteUploadPreSubmission(validRows);
        return true;
      } catch (e) {
        this.logService.sendError({
          component: "routes",
          message: `presubmitionValidation fallo en su procesamiento ${e.message}`
        });
        if (e instanceof NoRouteException) {
          showError(this.$t('routes.routeBatch.errors.noRoute'));
        } else if (e instanceof InvalidRouteTimeException) {
          showError(this.$t('routes.routeBatch.errors.pastLimitDates', { limitDate: 72 }));
          highlightError(null, e.identifier + 1);
          setSaveButtonAvailability(true);
        } else if (e instanceof NoTripsException) {
          showError(this.$t('routes.routeBatch.errors.noTrip'));
          setSaveButtonAvailability(true);
        } else if (e instanceof NoActivitiesException) {
          showError(this.$t('routes.routeBatch.errors.noActivity'));
          setSaveButtonAvailability(true);
        } else if (e instanceof NoValidSpot) {
          showError(this.$t('routes.routeBatch.errors.notEnoughParameters'));
          setSaveButtonAvailability(true);
        } else if (e instanceof InvalidAssignationException) {
          showError(this.$t('routes.routeBatch.errors.invalidAssignation'));
          setSaveButtonAvailability(true);
        } 
        return false;
      }
    },
    filter() {
      this.activeFilter();
      this.currentTab = 'rutas';
      this.handlePageChange();
    },
    async prepareSpotBody(trip) {
      try {
        let spotForm = {
          address: {
            city: trip.City,
            postalCode: null,
            state: trip.State,
            street: trip.Street,
            lat: null,
            lon: null,
            country: {
              id: this.countryList.find((country) => country.name === trip.Country).id,
              name: trip.Country,
            },
          },
          type: 'Temporal',
        };
        console.log('LLegando el spotform', spotForm);
        return spotForm;
      } catch (error) {
        this.logService.sendError({
          component: "routes",
          message: `prepareSpotBody fallo en su procesamiento ${error.message}`
        });
        console.log(error);
        showAlert('Error',this.$t('routes.routeBatch.errors.invalidAddress'),'error');
        throw error;
      }
    },
    async processExcel() {
      this.isCrudBusy = true;
      try {
        for (const element of this.rowsExcelTranform) {
          for (const trip of element.trips) {
            if (trip.tripDestination === this.$t('routes.routeBuilder.otros.crearNuevoDestino')) {
              let spotTemporal = await this.prepareSpotBody(trip);
              trip.destinationTemporal = spotTemporal;
              trip.type = 'Temporal';
            } else {
              trip.type = 'Existente';
            }

            let specificVehicle = null, specificDriver = null;
            
            specificVehicle = this.dynamicOptions.vehicle.find((v) => v.plateAndClient === trip.vehicle);
            specificDriver = this.dynamicOptions.driver.find((d) => d.fullNameAndClient === trip.operator);    

            if (trip.vehicle != undefined && trip.vehicle != null && trip.vehicle != "" && trip.operator != undefined && trip.operator != null && trip.operator != "") {
              trip.setOperatorDirect = {
                idDriver: specificDriver.id,
                idVehicle: specificVehicle.id,
                idOperator: this.$store.getters.loggedUser['idUser'],
              };
            } else {
              trip.setOperatorDirect = null;
            }
          }
        }
        this.dynamicOptions.spots = await this.spotService.getSpots();
        const result = await this.routeService.submitMassiveRoutes(
          this.rowsExcelTranform,
          this.dynamicOptions.spots,
          this.staticOptions.activityType,
          this.dynamicOptions.itemType,
          this.tags,
        );

        if (result.status === 'DONE') {
          /* closeUserMessage();
          await new Promise((resolve) => setTimeout(resolve, 200));
          showUserMessage('Carga procesada exitosamente', 'lightseagreen');
          await new Promise((resolve) => setTimeout(resolve, 1000));
          this.closeExcel();
          setSaveButtonAvailability(true); */
          showAlert(
            this.$t('routes.routeBatch.messages.title'),
            this.$t('routes.routeBatch.messages.success'),
            'success',
          );
          this.closeModal('save-massive-modal')
        } else if (result.status === 'FAIL') {
          showAlert(
            'Error',
            result.message,
            'error',
          );
        } else {
          this.closeModal('save-massive-modal')
          if (result.message === 'noResponse') {
            showAlert(
              'Error',
              'Error:' + this.$t('routes.routeBatch.messages.noResponse'),
              'error',
            );//No hay respuesta por parte del servidor
          } else if (result.message === 'timeout') {
            showAlert(
              'Error',
              'Error', this.$t('routes.routeBatch.messages.timeout'),
              'error',
            );//Intentos excedidos, espere un poco mas y luego refresque la pagina.
          } else {
            showAlert(
              'Error',
              'Error: ' + result.message,
              'error',
            );
          }
        }
        this.loadRoutes();
      } catch (e) {
        console.log(e);
        this.logService.sendError({
          component: "routes",
          message: `processExcel fallo en su procesamiento ${e.message}`
        });
        if (e instanceof DocumentExistsException) {
          showAlert(
            'Error',
            this.$t('routes.routeBatch.errors.documentExists') + ': ' + e.identifier,
            'error',
          );
        } else {
          showAlert(
            'Error',
            this.$t('routes.routeBatch.errors.generic'),
            'error',
          );
        }
      }
      this.isCrudBusy = false;
    },
    /* metodos de interaccion con usuario */
    queryRouteRemoval(id) {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('routes.formulario.confirmacion.mensaje'),
        () => {
          this.routes = this.routes.filter((i) => i.id !== id);
          this.routeService.deleteRoute(id);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    changeTab(navBar) {
      const ranking = ['rutas', 'viajes', 'actividades', 'documentos', 'items'];
      const previousTabIndex = ranking.indexOf(this.currentTab);
      this.currentTab = navBar;
      const currentTabIndex = ranking.indexOf(this.currentTab);
      if (currentTabIndex > previousTabIndex) {
        this.loadByTab(navBar);
      }
    },
    async getValueExtraDataTrips(){
      const url = `${this.$store.getters.urlAPI}/trip/extraDataValues`;
      try{
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };

        const response = await axios.get(url, config);

        return response.data.data;
        
      }catch(e){
        console.log(e);
        return [];
      }
    },
    async handlePageChange() {
      console.log('hey there');
      this.routes = [];
      this.selectedTrip = null;
      this.selectedActivity = null;
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedRoute = null;
      this.loadByTab(this.currentTab);
    },
    async loadByTab(navBar) {
      this.isBusy = true;
      if (navBar === 'rutas') {
        await this.loadRoutes();
      } else if (navBar === 'viajes') {
        await this.loadTrips();
      } else if (navBar === 'actividades') {
        await this.loadActivities();
      } else if (navBar === 'documentos') {
        await this.loadDocuments();
      } else if (navBar === 'items') {
        await this.loadItemsDetails();
      }
      this.isBusy = false;
    },
    async viewRow(row) {
      showRoutesForm(row, () => {});
    },
    async viewRowTrips(row) {
      showTripsForm(row, 'view', () => {});
    },
    activeFilter() {
      this.showFilters = !this.showFilters;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.showFilters && !this.isFilterClicked) {
        this.showFilters = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    async getAddressBySpot(spotId) {
      try {
        const currentSpot = this.dynamicOptions.spots.find((spot) => spot.id === spotId);
        return currentSpot.address;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    onFiltered() {
      this.currentPage = 1;
    },
    onRouteClicked(item, index, event) {
      this.selectedTrip = null;
      this.selectedActivity = null;
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedRoute = item.id;
      this.currentPageTrip = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('viajes');
      }
    },
    onTripClicked(item, index, event) {
      this.selectedActivity = null;
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedTrip = item.id;
      this.currentPageActivity = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('actividades');
      }
    },
    onActivityClicked(item, index, event) {
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedActivity = item.id;
      this.currentPageDocument = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('documentos');
      }
    },
    onDocumentClicked(item, index, event) {
      this.selectedItem = null;
      this.selectedDocument = item.id;
      this.currentPageItem = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('items');
      }
    },
    async prepareCancelRoute(route) {
      this.routeToCancel = await route.id;
      this.showModal('cancel-route-modal');
    },
    async endRoute() {
      const url = `${this.$store.getters.urlAPI}/route/${this.routeSelectedEnd.id}/ended`;
      console.log('url', url);
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      console.log('config', config);
      const body = { observation: this.temporalCommentEndRoute };
      try {
        await axios.patch(url, body, config);
        showAlert(this.$t('routes.success.title'), this.$t('routes.success.message'));
        this.handlePageChange();
      } catch (e) {
        this.logService.sendError({
          component: "routes",
          message: `endRoute fallo en su procesamiento ${e.message}`
        });
        showAlert('Error', e.response.data);
      }
    },
    /**
     * Metodo encargado de cancelar una ruta y recargar la vista
     */
    async cancelRoute() {
      this.loadingSpinnerHelperVariables.cancelRoute.indexAssigned = this.routeToCancel;
      this.loadingSpinnerHelperVariables.cancelRoute.unAssignedNotLoading = false;
      this.isCancelRouteBusy = true;
      await this.sendCancelRoute(this.routeToCancel);
      this.isCancelRouteBusy = false;
      this.isBusy = true;
      this.loadingSpinnerHelperVariables.cancelRoute.indexAssigned = -1;
      this.loadingSpinnerHelperVariables.cancelRoute.unAssignedNotLoading = true;
      await this.loadRoutes();
      this.isBusy = false;
      this.closeModal('cancel-route-modal');
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    /**
     * Metodo que retorna a la vista anterior.
     * @param {String} shortCutPath, nombre de la ruta.
     * @returns vista anterior.
     */
    returnToPage(shortCutPath) {
      return this.$router.push({ name: shortCutPath });
    },
    /* metodos de procesamiento de datos para renderizado */
    getTypeItem(id) {
      for (let itemDataObj of this.itemData) {
        if (id === itemDataObj.id) {
          return this.getDescTypeItem(itemDataObj.idItem);
        }
      }
      return '-';
    },
    getDescTypeItem(id) {
      for (let itemType of this.itemTypeData) {
        if (id === itemType.id) {
          return itemType.name;
        }
      }
      return '-';
    },
    getCodeItem(id) {
      for (let itemDataObj of this.itemData) {
        if (id === itemDataObj.id) {
          return itemDataObj.code;
        }
      }
      return '-';
    },
    getNameStatusRoute(id) {
      for (const statusRoute of this.statusOption) {
        if (id === statusRoute.id) {
          return statusRoute.name;
        }
      }
      return '';
    },
    shouldShowAssign(state) {
      const allowedStates = ['NOTASSIGNED', 'TOBEASSIGNED', 'ASSIGNED', 'TOBEUNASSIGNED'];
      return allowedStates.includes(state);
    },
    shouldShowActivityCompletion(state) {
      const allowedStates = ['ONGOING', 'ENDED', 'ENDEDINCOMPLETE'];
      return allowedStates.includes(state);
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },
    formatNominalTime(value) {
      return formatNominalTime(value);
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que deriva a otra vista dado ciertos parametros.
     * Prioridad al cambiar de vista: Preparar filtrado instantaneo por id de ruta.
     * @param {Integer} routeId, es la id de la ruta seleccionada.
     * @param {String} path, es el nombre de la vista a la que se desea ir.
     * @returns A la nueva vista.
     */
    async goToAnotherPage(routeId, path) {
      await this.$store.commit('saveShortCutPathOrigin', 'RouteBoard');
      await this.$store.commit('saveIdRouteFlash', routeId);
      return this.$router.push({ name: path });
    },
    /**
     * Metodo que limpia el filtrado.
     */
    cleanFilter() {
      this.filters.from = null;
      this.filters.until = null;
      this.filters.driver = null;
      this.filters.vehicle = null;
      this.filters.origin = null;
      this.filters.destination = null;
      this.filters.name = null;
      this.filters.routeId = null;
      this.filters.routeStatus = null;
      this.filters.documentNumber = null;
      this.filters.extraData = null;
    },
    checkRoutes() {
      if (this.selectedAllRoute) {
        this.checkAllRoute();
      } else {
        this.unCheckAllRoute();
      }
    },
    checkAllRoute() {
      this.routeSelected = [];
      for (const route of this.routes) {
        if (route.status === 1 || route.status === 4) {
          this.routeSelected.push(route.id);
        }
      }
    },
    unCheckAllRoute() {
      this.routeSelected = [];
    },
    cleanCheckBox() {
      this.selectedAllRoute = false;
      this.routeSelected = [];
    },
    massRouteCancelConfirmation() {
      showConfirmation(
        this.$t('common.modals.titulo'),
        this.$t('routes.routeBatch.messages.massRouteCancel', { routeSelected: this.routeSelected.length }),
        () => {
          this.massRouteCancel();
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    massRouteDeleteConfirmation() {
      showConfirmation(
        this.$t('common.modals.titulo'),
        this.$t('routes.routeBatch.messages.massRouteDelete', { routeSelected: this.routeSelected.length }),
        () => {
          this.massRouteDelete();
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    async massRouteCancel() {
      this.isBusy = true;
      const url = `${this.$store.getters.urlAPI}/route/massCanceled`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const result = await this.axios.patch(url, this.routeSelected, config);
      if (result.status === 200) {
        showAlert(
          this.$t('routes.routeBatch.messages.title'),
          this.$t('routes.routeBatch.messages.massCancelSuccess'),
          'success',
        );
      } else {
        showAlert(
          this.$t('routes.routeBatch.messages.errorTitle'),
          this.$t('routes.routeBatch.messages.unexpectedError'),
          'error',
        );
      }
      await this.loadRoutes();
      this.isBusy = false;
    },
    onBeforeValidation(schema, content, locale, contents, schemaKey, ignoreEmpty, updateCell) {
      if (schemaKey == 'activities') {
        for (let i = 0; i < content.length; i++) {
          let row = content[i];
          if (row.activityType === 'DELIVERY' || row.activityType === 'ENTREGA') {
            updateCell(schemaKey, i, 'activityType', this.$t('activities.formulario.campos.typeOptions.DELIVERY'));
          }
          if (row.activityType === 'COLLECTION' || row.activityType === 'RECOGIDA') {
            updateCell(schemaKey, i, 'activityType', this.$t('activities.formulario.campos.typeOptions.COLLECTION'));
          }
          if (row.activityType === 'VISIT' || row.activityType === 'VISITA') {
            updateCell(schemaKey, i, 'activityType', this.$t('activities.formulario.campos.typeOptions.VISIT'));
          }
        }
      }
      return true;
    },
    async massRouteDelete() {
      this.isBusy = true;
      const url = `${this.$store.getters.urlAPI}/route/massDelete`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const result = await this.axios.post(url, this.routeSelected, config);
      if (result.status === 200) {
        showAlert(
          this.$t('routes.routeBatch.messages.title'),
          this.$t('routes.routeBatch.messages.massDeleteSuccess'),
          'success',
        );
      } else {
        showAlert(
          this.$t('routes.routeBatch.messages.errorTitle'),
          this.$t('routes.routeBatch.messages.unexpectedError'),
          'error',
        );
      }
      await this.loadRoutes();
      this.isBusy = false;
    },
    /**
     * metodo que transforma el nombre de spot si es que es temporal
     * @param {Json} address
     * @param {String} nullCase
     * @returns
     */
    transformNameAddress(address, nullCase) {
      let destination;
      if (address) {
        if (address.type !== 'Temporal') {
          destination = address.name;
        } else {
          const splitAddress = address.name.split(',');
          destination = `${splitAddress[0]}, ${splitAddress[1]}`;
        }
      } else {
        destination = nullCase;
      }
      return destination;
    },
    async buildExcelPro() {
      //Metodo que llena el dropdown del excel con datos de tipo de vehículos extra (por cliente)
      const wb = new ExcelJS.Workbook();
      let ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.routes'));
      let headers = [
        { header: this.$t('routes.routeBatch.campos.routeName'), key: 'name', width: 40 },
        { header: this.$t('routes.routeBatch.campos.origin'), key: 'origin', width: 30 },
        { header: this.$t('routes.routeBatch.campos.startDate'), key: 'startDate', width: 30 },
        { header: this.$t('routes.routeBatch.campos.startTime'), key: 'startTime', width: 30 },
        { header: this.$t('routes.routeBatch.campos.loadTime'), key: 'loadTime', width: 30 },
        { header: this.$t('routes.routeBatch.campos.unloadtime'), key: 'unloadTime', width: 30 },
        {width: 30 },
      ];
      ws.columns = headers;
      ws.getRow(1).height = 18

        //Sacar celdas de headers
        let A1 = ws.getCell('A1');
        let B1 = ws.getCell('B1');
        let C1 = ws.getCell('C1');
        let D1 = ws.getCell('D1');
        //Relleno celdas
        A1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        B1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        C1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        D1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        //Comentarios celdas
        A1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.routeName')},
          ],
          editAs: "twoCells"
        };
        B1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.origin')},
          ],
          editAs: "twoCells"
        };
        C1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.initDate')},
          ],
          editAs: "twoCells"
        };
        D1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.initHour')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('E1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.loadTime')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('F1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.unloadTime')},
          ],
          editAs: "twoCells"
        };


      for (let i = 0; i < this.dynamicOptions.spots.length; i++) {
        if (this.dynamicOptions.spots[i].type !== 'Temporal') {
          ws.getCell(`$BB$${i+1}`).value = this.dynamicOptions.spots[i].name;
        } else {
          const splitAddress = this.dynamicOptions.spots[i].name.split(',');
          ws.getCell(`$BB$${i+1}`).value = `${splitAddress[0]}, ${splitAddress[1]}`;
        }
      }

      for (let i = 2; i < 200; i++) {
        ws.getCell(`B${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$BB$1:$BB$${this.dynamicOptions.spots.length}`],
        };
      }

      ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.trips'));
      headers = [
        { header: this.$t('routes.routeBatch.campos.routeName'), key: 'name', width: 40 },
        { header: this.$t('routes.routeBatch.campos.tripNumber'), key: 'tripNumber', width: 15 },
        { header: this.$t('routes.routeBatch.campos.destination'), key: 'tripDestination', width: 30 },
        { header: this.$t('routes.routeBatch.campos.timeEdit'), key: 'timeEdit', width: 30 },
        { header: this.$t('routes.routeBatch.campos.operator'), key: 'operator', width: 30 },
        { header: this.$t('routes.routeBatch.campos.vehicle'), key: 'vehicle', width: 30 },
        { header: this.$t('routes.routeBatch.campos.extraField'), key: 'extraField', width: 30 },
        { header: this.$t('routes.routeBatch.campos.street'), key: 'Street', width: 30 },
        { header: this.$t('routes.routeBatch.campos.city'), key: 'City', width: 30 },
        { header: this.$t('routes.routeBatch.campos.state'), key: 'State', width: 30 },
        { header: this.$t('routes.routeBatch.campos.country'), key: 'Country', width: 30 },
        {width: 30 },
      ];
      ws.columns = headers;
      ws.getRow(1).height = 18

        //Sacar celdas de headers
        A1 = ws.getCell('A1');
        B1 = ws.getCell('B1');
        C1 = ws.getCell('C1');
        //Relleno celdas
        A1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        B1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        C1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        //Comentarios celdas
        A1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.routeName')},
          ],
          editAs: "twoCells"
        };
        B1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.tripNumber')},
          ],
          editAs: "twoCells"
        };
        C1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.destination')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('D1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.tripTime')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('E1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.driver')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('F1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.vehicle')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('G1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.extraField')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('H1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optionalFields')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('I1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optionalFields')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('J1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optionalFields')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('K1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optionalFields')},
          ],
          editAs: "twoCells"
        };
        

      let parentWorksheet = this.$t('routes.routeBatch.sheets.routes');
      const fromReference = 2;
      const toReference = 202;
      for (let i = 2; i <= 202; i++) {
        ws.getCell('ZZ' + i).value = {
          formula: `=IFERROR(INDEX('${
            parentWorksheet
          }'!$A$${fromReference}:$A$${toReference}, MATCH(0,COUNTIF($ZZ$1:ZZ${i - 1}, '${
            parentWorksheet
          }'!$A$${fromReference}:$A$${toReference}), 0)),"")`,
          result: 200,
          shareType: 'array',
          ref: `ZZ${i}:ZZ${i}`,
        };
      }

      for (let i = 0; i < 198; i++) {
        ws.getCell(`$B$${i+2}`).value = i + 1;
      }
      
      ws.getCell(`$BC$${1}`).value = this.$t('routes.routeBuilder.otros.crearNuevoDestino');
      for (let i = 0; i < this.dynamicOptions.spots.length; i++) {
        //A la celda se le suma un +2, para que el primer spot no pise la opción de crear nuevo destino
        if (this.dynamicOptions.spots[i].type !== 'Temporal') {
          ws.getCell(`$BC$${i+2}`).value = this.dynamicOptions.spots[i].name;
        } else {
          const splitAddress = this.dynamicOptions.spots[i].name.split(',');
          ws.getCell(`$BC$${i+2}`).value = `${splitAddress[0]}, ${splitAddress[1]}`;
        }
      }
      
      for (let i = 0; i < this.dynamicOptions.driver.length; i++) {
        ws.getCell(`$BE$${i+1}`).value = this.dynamicOptions.driver[i].fullNameAndClient;
      }
      for (let i = 0; i < this.dynamicOptions.vehicle.length; i++) {
        ws.getCell(`$BF$${i+1}`).value = this.dynamicOptions.vehicle[i].plateAndClient;
      }
      for (let i = 0; i < this.countryList.length; i++) {
        ws.getCell(`$BJ$${i+1}`).value = this.countryList[i].name;
      }
      for (let i = 2; i < 200; i++) {
        ws.getCell(`A${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`=OFFSET($ZZ$2,0,0,199-COUNTBLANK($ZZ$2:$ZZ$201),1)`],
        };
        ws.getCell(`C${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$BC$1:$BC$${(this.dynamicOptions.spots.length + 1)}`],
        };
        if (this.dynamicOptions.driver.length > 0) {
          ws.getCell(`E${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BE$1:$BE$${this.dynamicOptions.driver.length}`],
          };
        }
        if (this.dynamicOptions.vehicle.length > 0) {
          ws.getCell(`F${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BF$1:$BF$${this.dynamicOptions.vehicle.length}`],
          };
        }

        ws.getCell(`J${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$BJ$1:$BJ$${this.countryList.length}`],
        };
      }

      ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.activities'));
      headers = [
        { header: this.$t('routes.routeBatch.campos.tripNumber'), key: 'tripNumber', width: 15 },
        { header: this.$t('routes.routeBatch.campos.activityName'), key: 'activityName', width: 40 },
        { header: this.$t('routes.routeBatch.campos.activityNumber'), key: 'activityNumber', width: 20 },
        { header: this.$t('routes.routeBatch.campos.activityType'), key: 'activityType', width: 15 },
        { header: this.$t('routes.routeBatch.campos.duration'), key: 'duration', width: 20 },
        { header: this.$t('routes.routeBatch.campos.volume'), key: 'volume', width: 15 },        
        { header: this.$t('routes.routeBatch.campos.weight'), key: 'weight', width: 15 },
        { header: this.$t('routes.routeBatch.campos.tag'), key: 'tag', width: 30 },        
        { header: this.$t('routes.routeBatch.campos.customerName'), key: 'customerName', width: 30 },
        { header: this.$t('routes.routeBatch.campos.customerLegalNumber'), key: 'customerLegalNumber', width: 30 },
        { header: this.$t('routes.routeBatch.campos.customerPhone'), key: 'customerPhone', width: 30 },
        { header: this.$t('routes.routeBatch.campos.customerEmail'), key: 'email', width: 30 },
        {width: 30 },
      ];
      ws.columns = headers;
      ws.getRow(1).height = 18

        //Sacar celdas de headers
        A1 = ws.getCell('A1');
        B1 = ws.getCell('B1');
        C1 = ws.getCell('C1');
        D1 = ws.getCell('D1');
        let E1 = ws.getCell('E1');
        //Relleno celdas
        A1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        B1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        C1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        D1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        E1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        //Comentarios celdas
        A1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.tripNumber')},
          ],
          editAs: "twoCells"
        };
        B1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.activityName')},
          ],
          editAs: "twoCells"
        };
        C1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.activityNumber')},
          ],
          editAs: "twoCells"
        };
        D1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.activityType')},
          ],
          editAs: "twoCells"
        };
        E1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.duration')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('F1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.volume')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('G1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.weight')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('H1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.tag')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('I1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.customerName')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('J1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.customerLegalNumber')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('K1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.customerPhone')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('L1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.customerEmail')},
          ],
          editAs: "twoCells"
        };

      parentWorksheet = this.$t('routes.routeBatch.sheets.trips');      
      for (let i = 2; i <= 202; i++) {
        ws.getCell('ZZ' + i).value = {
          formula: `=IFERROR(INDEX('${
            parentWorksheet
          }'!$B$${fromReference}:$B$${toReference}, MATCH(0,COUNTIF($ZZ$1:ZZ${i - 1}, '${
            parentWorksheet
          }'!$B$${fromReference}:$B$${toReference}), 0)),"")`,
          result: 200,
          shareType: 'array',
          ref: `ZZ${i}:ZZ${i}`,
        };
      }

      for (let i = 0; i < 198; i++) {
        ws.getCell(`$C$${i+2}`).value = i + 1;
      }

      for (let i = 0; i < this.staticOptions.activityType.length; i++) {
        ws.getCell(`$BD$${i+1}`).value = this.$t(this.staticOptions.activityType[i].text);
      }

      for (let i = 0; i < this.tags.length; i++) {
        ws.getCell(`$BH$${i+1}`).value = this.$t(this.tags[i].name);
      }
      
      for (let i = 2; i < 200; i++) {
        ws.getCell(`A${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`=OFFSET($ZZ$2,0,0,199-COUNTBLANK($ZZ$2:$ZZ$201),1)`],
        };
        ws.getCell(`D${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$BD$1:$BD$${this.staticOptions.activityType.length}`],
        };
        if (this.tags.length > 0) {
          ws.getCell(`H${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BH$1:$BH$${this.tags.length}`],
          };
        }
      }

      ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.documents'));
      headers = [
        { header: this.$t('routes.routeBatch.campos.activityNumber'), key: 'activityNumber', width: 20 },
        { header: this.$t('routes.routeBatch.campos.documentNumber'), key: 'documentNumber', width: 40 },
        {width: 60 },
      ];
      ws.columns = headers;
      ws.getRow(1).height = 18

        //Sacar celdas de headers
        A1 = ws.getCell('A1');
        B1 = ws.getCell('B1');
        //Relleno celdas
        A1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        B1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        //Comentarios celdas
        A1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.activityNumber')},
          ],
          editAs: "twoCells"
        };
        B1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.documentNumberDoc')},
          ],
          editAs: "twoCells"
        };

      parentWorksheet = this.$t('routes.routeBatch.sheets.activities');      
      for (let i = 2; i <= 202; i++) {
        ws.getCell('ZZ' + i).value = {
          formula: `=IFERROR(INDEX('${
            parentWorksheet
          }'!$C$${fromReference}:$C$${toReference}, MATCH(0,COUNTIF($ZZ$1:ZZ${i - 1}, '${
            parentWorksheet
          }'!$C$${fromReference}:$C$${toReference}), 0)),"")`,
          result: 200,
          shareType: 'array',
          ref: `ZZ${i}:ZZ${i}`,
        };
      }

      for (let i = 2; i < 200; i++) {
        ws.getCell(`A${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`=OFFSET($ZZ$2,0,0,199-COUNTBLANK($ZZ$2:$ZZ$201),1)`],
        };
      }

      ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.items'));
      headers = [
        { header: this.$t('routes.routeBatch.campos.documentNumber'), key: 'documentNumber', width: 20 },
        { header: this.$t('routes.routeBatch.campos.itemType'), key: 'itemType', width: 40 },
        { header: this.$t('routes.routeBatch.campos.code'), key: 'code', width: 30 },
        { header: this.$t('routes.routeBatch.campos.quantity'), key: 'itemQuantity', width: 30 },
        { header: this.$t('routes.routeBatch.campos.unitPrice'), key: 'itemUnitPrice', width: 30 },
        {width: 30 },
      ];
      ws.columns = headers;
      ws.getRow(1).height = 18

        //Sacar celdas de headers
        A1 = ws.getCell('A1');
        B1 = ws.getCell('B1');
        D1 = ws.getCell('D1');
        //Relleno celdas
        A1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        B1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        D1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        //Comentarios celdas
        A1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.documentNumber')},
          ],
          editAs: "twoCells"
        };
        B1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.item')},
          ],
          editAs: "twoCells"
        };
        D1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.required')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.quantity')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('C1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.code')},
          ],
          editAs: "twoCells"
        };
        ws.getCell('E1').note = {
          texts: [
            {'font': {'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.unitPrice')},
          ],
          editAs: "twoCells"
        };

      parentWorksheet = this.$t('routes.routeBatch.sheets.documents');      
      for (let i = 2; i <= 202; i++) {
        ws.getCell('ZZ' + i).value = {
          formula: `=IFERROR(INDEX('${
            parentWorksheet
          }'!$B$${fromReference}:$B$${toReference}, MATCH(0,COUNTIF($ZZ$1:ZZ${i - 1}, '${
            parentWorksheet
          }'!$B$${fromReference}:$B$${toReference}), 0)),"")`,
          result: 200,
          shareType: 'array',
          ref: `ZZ${i}:ZZ${i}`,
        };
      }
      
      for (let i = 0; i < this.dynamicOptions.itemType.length; i++) {
        ws.getCell(`$BB$${i+1}`).value = this.$t(this.dynamicOptions.itemType[i].name);
      }

      for (let i = 2; i < 200; i++) {
        ws.getCell(`A${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`=OFFSET($ZZ$2,0,0,199-COUNTBLANK($ZZ$2:$ZZ$201),1)`],
        };
        if (this.dynamicOptions.itemType.length > 0) {
          ws.getCell(`B${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BB$1:$BB$${this.dynamicOptions.itemType.length}`],
          };
        }
      }

      const buffer = await wb.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileExtension = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      
      saveAs(blob, 'excel_rutas_masivo_template' + fileExtension);
    },
    addfile(event) {
      this.file = event.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result;
        let data = new Uint8Array(this.arrayBuffer);
        let arr = new Array();
        for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        let bstr = arr.join('');
        let workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });

        this.routeRowsExcel = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { raw: true });
        this.tripRowsExcel = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[1]], { raw: true });
        this.activityRowsExcel = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[2]], { raw: true });
        this.documentRowsExcel = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[3]], { raw: true });
        this.itemRowsExcel = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[4]], { raw: true });
        this.readFileExcel();
      };
    },
    async readFileExcel() {
      this.rowsExcelTranform = [];
      this.resultValidation = null;
      this.prepareFileExcel();
      let index = 0;
      for (let route of this.routeRowsExcel) {
        if (route.name || route.origin 
          || route.startDate || route.startTime 
          || route.loadTime || route.unloadTime) {
          this.resultValidation = this.validateRouteRequiredExcel(route,index);
          if (!this.resultValidation) {
            route.startDate = moment(route.startDate).format("YYYY-MM-DD");
            route.startTime = moment(route.startTime).format('HH:mm');
            route.trips = [];
            this.rowsExcelTranform.push(route);
          } else {
            break;
          }
          index += 1;
        }
      }

      let suggestedTripNumber = [];
      if (!this.resultValidation) {
        index = 0;
        for (let trip of this.tripRowsExcel) {
          if(trip.name  
            || trip.tripDestination || trip.timeEdit 
            || trip.operator || trip.vehicle 
            || trip.Street || trip.City 
            || trip.State || trip.Country) {
            this.resultValidation = this.validateTripRequiredExcel(trip,index);
            if (!this.resultValidation) {
              for (let route of this.rowsExcelTranform) {
                if (trip.name === route.name) {
                  const currentSpot = this.dynamicOptions.spots.find((s) => {
                    //Verifico si el spot del listado es temporal
                    if (s.type !== 'Temporal' && s.name === trip.tripDestination) {
                      return s;
                    }
                    //Si es temporal entonces transformo el nombre del spot
                    else if (s.type === 'Temporal') {
                      const splitAddress = s.name.split(',');
                      const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
                      if (newName === trip.tripDestination) {
                        return s;
                      }
                    }
                  });
                  if (currentSpot == undefined) {
                    trip.Address =  null;
                  } else {
                    const address = await this.getAddressBySpot(currentSpot.id);
                    trip.Address = address.street + ', ' + address.city + ', ' + address.state;
                  }
                  trip.activities = [];
                  route.trips.push(trip);
                  suggestedTripNumber.push(trip.tripNumber);
                }            
              }
            } else {
              break;
            }
            index += 1;
          }
        }
      }

      let suggestedActivity = [];
      if (!this.resultValidation) {
        index = 0;
        for (let activity of this.activityRowsExcel) {
          if (activity.tripNumber || activity.activityName 
            || activity.activityType 
            || activity.duration || activity.volume 
            || activity.weight || activity.tag 
            || activity.customerName || activity.customerLegalNumber
            || activity.customerPhone || activity.email) {
            this.resultValidation = this.validateActivityRequiredExcel(activity,index,suggestedTripNumber);
            if (!this.resultValidation) {
              for (let route of this.rowsExcelTranform) {
                for (let trip of route.trips) {
                  if (trip.tripNumber === activity.tripNumber) {
                    activity.documents = [];
                    trip.activities.push(activity);
                    suggestedActivity.push(activity.activityNumber);
                  }
                }   
              }
            } else {
              break;
            }
            index += 1;
          }
        }
      }

      let suggestedDocument = [];
      if (!this.resultValidation) {
        index = 0;
        for (let document of this.documentRowsExcel) {
          if (document.activityNumber || document.documentNumber) {
            this.resultValidation = this.validateDocumentRequiredExcel(document,index,suggestedActivity);
            if (!this.resultValidation) {
              for (let route of this.rowsExcelTranform) {
                for (let trip of route.trips) {
                  for (let activity of trip.activities) {
                    if (activity.activityNumber === document.activityNumber) {
                      document.items = [];
                      activity.documents.push(document);
                      suggestedDocument.push(document.documentNumber);
                    }
                  }
                }   
              }
            } else {
              break;
            }
            index += 1;
          }
        }
      }

      if (!this.resultValidation) {
        index = 0;
        for (let item of this.itemRowsExcel) {
          if (item.documentNumber || item.itemType 
            || item.itemQuantity || item.itemUnitPrice) {
            this.resultValidation = this.validateItemRequiredExcel(item,index,suggestedDocument);
            if (!this.resultValidation) {
              for (let route of this.rowsExcelTranform) {
                for (let trip of route.trips) {
                  for (let activity of trip.activities) {
                    for (let document of activity.documents) {
                      if (item.documentNumber === document.documentNumber) {
                        item.code = this.dynamicOptions.itemType.find((element) => element.name === item.itemType) === undefined ? '' : this.dynamicOptions.itemType.find((element) => element.name === item.itemType).code;
                        document.items.push(item);
                      }
                    }
                  }
                }   
              }
            } else {
              break;
            }
            index += 1;
          }
        }
      }

      if (this.resultValidation) {
        this.missRequiredData = true;
        showAlert('Error', this.resultValidation.message, 'error');
        this.closeModal('save-massive-modal')
      }
    },
    async prepareFileExcel() {
      //Rutas
      let name = this.$t('routes.routeBatch.campos.routeName');
      let origin = this.$t('routes.routeBatch.campos.origin');
      let startDate = this.$t('routes.routeBatch.campos.startDate');
      let startTime = this.$t('routes.routeBatch.campos.startTime');
      let loadTime = this.$t('routes.routeBatch.campos.loadTime');
      let unloadTime = this.$t('routes.routeBatch.campos.unloadtime');

      for (let row of this.routeRowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === name) {
            row.name = value;
          } else if (key.trim() === origin) {
            row.origin = value;
          } else if (key.trim() === startDate) {
            row.startDate = value;
          }  else if (key.trim() === startTime) {
            row.startTime = value;
          }  else if (key.trim() === loadTime) {
            row.loadTime = value;
          }  else if (key.trim() === unloadTime) {
            row.unloadTime = value;
          } 
        });
      }

      //Viajes
      name = this.$t('routes.routeBatch.campos.routeName');
      let tripNumber = this.$t('routes.routeBatch.campos.tripNumber');
      let tripDestination = this.$t('routes.routeBatch.campos.destination');
      let timeEdit = this.$t('routes.routeBatch.campos.timeEdit');
      let operator = this.$t('routes.routeBatch.campos.operator');
      let vehicle = this.$t('routes.routeBatch.campos.vehicle');
      let extraField = this.$t('routes.routeBatch.campos.extraField');
      let Street = this.$t('routes.routeBatch.campos.street');
      let City = this.$t('routes.routeBatch.campos.city');
      let State = this.$t('routes.routeBatch.campos.state');
      let Country = this.$t('routes.routeBatch.campos.country');

      for (let row of this.tripRowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === name) {
            row.name = value;
          } else if (key.trim() === tripNumber) {
            row.tripNumber = value;
          } else if (key.trim() === tripDestination) {
            row.tripDestination = value;
          } else if (key.trim() === timeEdit) {
            row.timeEdit = value;
          } else if (key.trim() === operator) {
            row.operator = value;
          } else if (key.trim() === vehicle) {
            row.vehicle = value;
          } else if (key.trim() === extraField) {
            row.extraField = value;
          } else if (key.trim() === Street) {
            row.Street = value;
          } else if (key.trim() === City) {
            row.City = value;
          } else if (key.trim() === State) {
            row.State = value;
          } else if (key.trim() === Country) {
            row.Country = value;
          }
        });
      }

      //Actividades
      tripNumber = this.$t('routes.routeBatch.campos.tripNumber');
      let activityName = this.$t('routes.routeBatch.campos.activityName');
      let activityNumber = this.$t('routes.routeBatch.campos.activityNumber');
      let activityType = this.$t('routes.routeBatch.campos.activityType');
      let duration = this.$t('routes.routeBatch.campos.duration');
      let volume = this.$t('routes.routeBatch.campos.volume');
      let weight = this.$t('routes.routeBatch.campos.weight');
      let tag = this.$t('routes.routeBatch.campos.tag');
      let customerName = this.$t('routes.routeBatch.campos.customerName');
      let customerLegalNumber = this.$t('routes.routeBatch.campos.customerLegalNumber');
      let customerPhone = this.$t('routes.routeBatch.campos.customerPhone');
      let email = this.$t('routes.routeBatch.campos.customerEmail');

      for (let row of this.activityRowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === tripNumber) {
            row.tripNumber = value;
          } else if (key.trim() === activityName) {
            row.activityName = value;
          } else if (key.trim() === activityNumber) {
            row.activityNumber = value;
          } else if (key.trim() === activityType) {
            row.activityType = value;
          } else if (key.trim() === duration) {
            row.duration = value;
          } else if (key.trim() === volume) {
            row.volume = value;
          } else if (key.trim() === weight) {
            row.weight = value;
          } else if (key.trim() === tag) {
            row.tag = value;
          } else if (key.trim() === customerName) {
            row.customerName = value;
          } else if (key.trim() === customerLegalNumber) {
            row.customerLegalNumber = value;
          } else if (key.trim() === customerPhone) {
            row.customerPhone = value;
          } else if (key.trim() === email) {
            row.email = value;
          }
        });
      }

      //Documentos
      activityNumber = this.$t('routes.routeBatch.campos.activityNumber');
      let documentNumber = this.$t('routes.routeBatch.campos.documentNumber');

      for (let row of this.documentRowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === activityNumber) {
            row.activityNumber = value;
          } else if (key.trim() === documentNumber) {
            row.documentNumber = value;
          }
        });
      }

      //Items
      documentNumber = this.$t('routes.routeBatch.campos.documentNumber');
      let itemType = this.$t('routes.routeBatch.campos.itemType');
      let code = this.$t('routes.routeBatch.campos.code');
      let itemQuantity = this.$t('routes.routeBatch.campos.quantity');
      let itemUnitPrice = this.$t('routes.routeBatch.campos.unitPrice');

      for (let row of this.itemRowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === documentNumber) {
            row.documentNumber = value;
          } else if (key.trim() === itemType) {
            row.itemType = value;
          } else if (key.trim() === code) {
            row.code = value;
          } else if (key.trim() === itemQuantity) {
            row.itemQuantity = value;
          } else if (key.trim() === itemUnitPrice) {
            row.itemUnitPrice = value;
          }
        });
      }
    },
    validateRouteRequiredExcel(row, index) {
      let rowProblem = null;
      if (row.name == null || row.name == undefined || row.name == '') {
        rowProblem = {
          status: 'FAIL',
          message: 'Nombre de ruta en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }

      if (rowProblem == null && (
        this.dynamicOptions.spots.find((element) => {
          //Verifico si el spot del listado es temporal
          if (element.type !== 'Temporal' && element.name === row.origin) {
            return element;
          }
          //Si es temporal entonces transformo el nombre del spot
          else if (element.type === 'Temporal') {
            const splitAddress = element.name.split(',');
            const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
            if (newName === row.origin) {
              return element;
            }
          }        
        }) === undefined 
        || row.origin == null || row.origin == undefined || row.origin == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Origen de ruta en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      if (rowProblem == null && (row.startDate == null || row.startDate == undefined || row.startDate == '' || !/^(?:(?:31(\/|-|)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(moment(row.startDate).format("DD-MM-YYYY")))) {
        rowProblem = {
          status: 'FAIL',
          message: 'Fecha de inicio de ruta en fila ' + (index + 1).toString() + ' debe contener una fecha valida (dd-mm-aaaa)',
        };
      }
      if (rowProblem == null && (row.startTime == null || row.startTime == undefined || row.startTime == '' || !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(moment(row.startTime).format('HH:mm')))) {
        rowProblem = {
          status: 'FAIL',
          message: 'Hora de inicio de ruta en fila ' + (index + 1).toString() + ' debe contener una hora valida (hh:mm)',
        };
      }
      return rowProblem;
    },
    validateTripRequiredExcel(row, index) {
      let rowProblem = null;
      if (row.name == null || row.name == undefined || row.name == '' || this.rowsExcelTranform.find((element) => element.name === row.name) === undefined) {
        rowProblem = {
          status: 'FAIL',
          message: 'Nombre de ruta de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      if (rowProblem == null && (row.tripNumber !== null && row.tripNumber == undefined && row.tripNumber == '')){
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de viaje en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }      
      if (rowProblem == null && (this.dynamicOptions.spots.find((element) => {
        //Verifico si el spot del listado es temporal
        if (element.type !== 'Temporal' && element.name === row.tripDestination) {
          return element;
        }
        //Si es temporal entonces transformo el nombre del spot
        else if (element.type === 'Temporal') {
          const splitAddress = element.name.split(',');
          const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
          if (newName === row.tripDestination) {
            return element;
          }
        }
      }) === undefined || row.tripDestination == null || row.tripDestination == undefined || row.tripDestination == '')) {
        if (this.$t('routes.routeBuilder.otros.crearNuevoDestino') !== row.tripDestination) {
          rowProblem = {
            status: 'FAIL',
            message: 'Destino de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      if (rowProblem == null && (row.operator !== null && row.operator == undefined && row.operator == '')){
        if (this.dynamicOptions.driver.find((element) => element.fullNameAndClient === row.operator) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Conductor de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      if (rowProblem == null && (row.vehicle !== null && row.vehicle == undefined && row.vehicle == '')){
        if (this.dynamicOptions.vehicle.find((element) => element.plateAndClient === row.vehicle) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Vehiculo de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      if (rowProblem == null && (row.Country !== null && row.Country !== undefined && row.Country !== '')){
        if (this.countryList.find((element) => element.name === row.Country) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Vehiculo de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      return rowProblem;
    },
    validateActivityRequiredExcel(row, index, suggestedTripNumber) {
      let rowProblem = null;
      if (row.tripNumber == null || row.tripNumber == undefined || row.tripNumber == '' || suggestedTripNumber.find((element) => element === row.tripNumber) === undefined) {
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de viaje de actividad en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      if (rowProblem == null && (row.activityName == null || row.activityName == undefined || row.activityName == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Nombre de actividad en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }
      if (rowProblem == null && (row.activityNumber == null || row.activityNumber == undefined || row.activityNumber == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de actividad en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }
      if (rowProblem == null && (this.staticOptions.activityType.find((element) => element.text === row.activityType) === undefined || row.activityType == null || row.activityType == undefined || row.activityType == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Tipo de actividad en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      if (rowProblem == null && (row.duration == null || row.duration == undefined || row.duration == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Duracion de actividad en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }
      if (rowProblem == null && (row.tag !== null && row.tag !== undefined && row.tag !== '')){
        if (this.tags.find((element) => element.name === row.tag) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Atributo de actividad en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      return rowProblem;
    },
    validateDocumentRequiredExcel(row, index, suggestedActivity) {
      let rowProblem = null;
      if (row.activityNumber == null || row.activityNumber == undefined || row.activityNumber == '' || suggestedActivity.find((element) => element === row.activityNumber) === undefined) {
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de actividad de documento en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      if (rowProblem == null && (row.documentNumber == null || row.documentNumber == undefined || row.documentNumber == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de documento en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      };
      
      return rowProblem;
    },
    validateItemRequiredExcel(row, index, suggestedDocument) {
      let rowProblem = null;
      if (row.documentNumber == null || row.documentNumber == undefined || row.documentNumber == '' || suggestedDocument.find((element) => element === row.documentNumber) === undefined) {
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de documento de item en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }
      if (rowProblem == null && (this.dynamicOptions.itemType.find((element) => element.name === row.itemType) === undefined || row.itemType == null || row.itemType == undefined || row.itemType == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Tipo de item en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }

      if (rowProblem == null && (row.itemQuantity == null || row.itemQuantity == undefined || row.itemQuantity == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Cantidad de item en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      };
      
      return rowProblem;
    },
    openSaveMassModal() {
      this.rowsExcelTranform = [];
      this.showModal('save-massive-modal');
    },
    timeFrameData(data){
      return `${this.formatDate(data.value[0], 'DD/MM/YY\xa0\xa0\xa0HH:mm')} hrs. - \n ${this.formatDate(data.value[1], 'DD/MM/YY\xa0\xa0\xa0HH:mm')} hrs.`
    },
  },
  computed: {
    /* carga de datos para excel */
    excelInfo() {
      return generateInformation((key) => this.$t(key));
    },
    localization() {
      return generateLocalization((key) => this.$t(key));
    },
    locale() {
      return this.$i18n.locale.substring(0, 2).toUpperCase();
    },
    excelSchema() {
      return generateMassiveRouteSchema(
        this.countryList,
        this.dynamicOptions.spots,
        this.staticOptions.activityType,
        this.dynamicOptions.itemType,
        (key) => this.$t(key),
        this.getAddressBySpot,
        this.tags,
        this.dynamicOptions.driver,
        this.dynamicOptions.vehicle
      );
    },
    /* campo virtual para cantidad de filas por pestaña activa */
    rows() {
      if (this.currentTab === 'rutas') {
        return this.items.length;
      } else if (this.currentTab === 'viajes') {
        return this.itemsTrips.length;
      } else if (this.currentTab === 'actividades') {
        return this.itemsActivities.length;
      } else if (this.currentTab === 'documentos') {
        return this.itemsDocuments.length;
      } else if (this.currentTab === 'items') {
        return this.itemsItems.length;
      }
    },
    staticOptions() {
      return {
        routeStatus: routeStatus.map((e) => ({
          ...e,
          text: this.$t(e.text),
        })),
        activityType: activityTypes.map((e) => ({
          ...e,
          text: this.$t(e.text),
        })),
        documentType: documentClasses.map((e) => ({
          ...e,
          text: this.$t(e.text),
        })),
      };
    },
    /* campos de tablas */
    fields() {
      return routeTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        class: 'text-center',
        tdClass: e.key === 'routeIcon' ? 'text-center' : 'small',
        sortable: !['shortcuts', 'actions'].includes(e.key),
      }));
    },
    fieldsTrips() {
      return tripTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        class: 'text-center',
        tdClass: 'small',
        sortable: false,
      }));
    },
    fieldsActivities() {
      return activityTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        ...baseCell,
      }));
    },
    fieldsDocuments() {
      return documentTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        ...baseCell,
      }));
    },
    fieldsItems() {
      return itemTableSchema.map((e) => ({
        ...e,
        label:
          e.label.split(' ').length > 1
            ? this.$t(e.label.split(' ')[0]) + ' ' + e.label.split(' ')[1]
            : this.$t(e.label),
        ...baseCell,
      }));
    },
    items() {
      return this.routes.map((r) => {
        const origin = this.transformNameAddress(r.origin, '-');
        const destination = this.transformNameAddress(
          r.destination,
          this.$t('routes.tabla.cabeceras.destinoDeUltimoViaje'),
        );
        return {
          ...r,
          status: r.status ? r.status : '-',
          //driver: r.driver ? r.driver.firstName + ' ' + r.driver.lastName : '-',
          //vehicle: r.vehicle ? r.vehicle.plate : '-',
          origin: origin,
          destination: destination,
          trips: r.trips ? r.trips.length : '-',
          isValid: r.isValid ? r.isValid : false,
        };
      });
    },
    itemsTrips() {
      let mapa = new Map();
      let existAssignation = false;
      //Si la ruta seleccionada no tien sus asignaciones vacias llena una lista map contodos los driver y vehículos
      if (
        this.routeInfoSelected != null &&
        (this.routeInfoSelected.assignations != undefined || this.routeInfoSelected.assignations != null)
      ) {
        this.routeInfoSelected.assignations.forEach((assign) => {
          if (assign.driver != undefined && assign.vehicle != undefined) {
            mapa.set(assign.id, [assign.driver, assign.vehicle, assign.cargo]);
          }
        });
        existAssignation = true;
      }
      //Verifica que trips de la ruta poseen al conductor o vehículo filtrado
      return this.trips.map((t) => {
        let isFilteredTrip = false;
        let driverAssign = null;
        let vehicleAssign = null;
        let cargoAssign = null;
        //solamente obtiene los datos del conductor y vehículo si su id de assignacion no es nulo
        if (existAssignation && (t.idAssignation != null || t.idAssignation != undefined)) {
          let idAssignation = mapa.get(t.idAssignation);
          if (idAssignation && t.idAssignation != undefined) {
            driverAssign = idAssignation[0];
            vehicleAssign = idAssignation[1];
            cargoAssign = idAssignation[2];
            if (this.filters.driver && this.filters.driver.length > 0) {
              isFilteredTrip = this.filters.driver.some((driver) => driverAssign.id == driver.id) ? true : false;
            }
            if (!isFilteredTrip && this.filters.vehicle && this.filters.vehicle.length > 0) {
              isFilteredTrip = this.filters.vehicle.some((vehicle) => vehicleAssign.id == vehicle.id) ? true : false;
            }
          }
        }
        if (!isFilteredTrip && this.filters.origin && this.filters.origin.length > 0) {
          isFilteredTrip = this.filters.origin.some((origin) => origin.id == t.origin.id) ? true : false;
        }
        if (!isFilteredTrip && this.filters.destination && this.filters.destination.length > 0) {
          isFilteredTrip = this.filters.destination.some((destination) => destination.id == t.destination.id)
            ? true
            : false;
        }
        const origin = this.transformNameAddress(t.origin, '-');
        const destination = this.transformNameAddress(t.destination, '-');
        return {
          ...t,
          route: '-',
          name: destination,
          origin: origin,
          address: t.destination && t.destination.address ? t.destination.address.street : '-',
          driver: driverAssign
            ? this.transformWords(driverAssign.firstName) + ' ' + this.transformWords(driverAssign.lastName)
            : '-',
          vehicle: vehicleAssign ? vehicleAssign.plate : '-',
          cargo: cargoAssign ? cargoAssign.plate : '-',
          originAddress: t.origin && t.origin.address ? t.origin.address.street : '-',
          timeFrame: [Date.parse(t.startDate), Date.parse(t.endDate)],
          dwell: t.duration ? t.duration : 0,
          journey: t.drivingTime ? t.drivingTime : 0,
          totalTime: t.duration && t.drivingTime !== undefined ? t.duration + t.drivingTime : 0,
          activities: t.activities ? t.activities.length : 0,
          _rowVariant: isFilteredTrip ? 'secondary' : '',
        };
      });
    },
    itemsActivities() {
      return this.activities.map((a) => {
        return {
          ...a,
          route: '-',
          trip: '-',
          time: a.duration,
          type: a.type ? a.type : 'DELIVERY',
          documents: a.documents ? a.documents.length : 0,
          name: a.name ? a.name : '-',
        };
      });
    },
    itemsDocuments() {
      return this.documents.map((d) => {
        return {
          ...d,
          route: '-',
          trip: '-',
          activity: '-',
          documentNumber: d.number,
          type: this.documentService.getType(d.type) ? this.documentService.getType(d.type).value : '-',
          items: d.items ? d.items.length : 0,
          time: d.time || 0,
        };
      });
    },
    itemsItems() {
      return this.itemsDetails.map((i) => {
        return {
          ...i,
          document: i.idDocument,
          type: this.getTypeItem(i.idItemData),
          code: this.getCodeItem(i.idItemData),
          unitMeasure: i.unitMeasure || '-',
          quantity: i.quantity || '-',
          extra1: i.extra1 || '-',
          extra2: i.extra2 || '-',
          extra3: i.extra3 || '-',
          extra4: i.extra4 || '-',
          extra5: i.extra5 || '-',
        };
      });
    },
    /* indicadores de tabla habilitada */
    isTripTabEnabled() {
      return !!this.selectedRoute;
    },
    isActivityTabEnabled() {
      return !!this.selectedRoute && !!this.selectedTrip;
    },
    isDocumentTabEnabled() {
      return !!this.selectedRoute && !!this.selectedTrip && !!this.selectedActivity;
    },
    isItemTabEnabled() {
      return !!this.selectedRoute && !!this.selectedTrip && !!this.selectedActivity && !!this.selectedDocument;
    },
  },
  watch: {
    '$store.getters.isUserReady'() {
      this.prepareData();
    },
  },
};
